import React from 'react';

export default function SearchesResults() {
  return (
    <h1>RESULTADO DE BUSQUEDAS</h1>
  );
}
